import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export function NotFound() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet | MA Hvidevareservice"
        description="Beklager, den side du leder efter findes ikke hos MA Hvidevareservice."
      />

      <section className="py-20 sm:py-28 bg-slate-50 flex-1 flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            404 – Siden blev ikke fundet
          </h1>

          <p className="text-base text-slate-600 leading-relaxed max-w-md mx-auto">
            Beklager, siden du leder efter findes ikke eller er blevet flyttet. Men vi hjælper dig gerne videre med dine hvidevarer.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 bg-sky-600 hover:bg-sky-700 text-white font-semibold text-sm rounded-lg transition-colors shadow-sm inline-flex items-center justify-center"
            >
              <span>Tilbage til forsiden</span>
            </Link>

            <Link
              to="/service-priser"
              className="w-full sm:w-auto px-6 py-3 bg-white hover:bg-slate-100 text-slate-900 border border-slate-300 font-semibold text-sm rounded-lg transition-colors inline-flex items-center justify-center gap-2"
            >
              <span>Se ydelser & priser</span>
            </Link>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm rounded-lg transition-colors inline-flex items-center justify-center gap-2"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;
